import { CardRarity, Rarity, Sport } from '__generated__/globalTypes';

export type SeasonCount = {
  count: number;
  season: {
    startYear: number;
    name: string;
  };
};

export type RarityCount = {
  count: number;
  rarity: Rarity;
};

export type CollectionCounts = {
  seasonsCount: SeasonCount[];
  raritiesCount: RarityCount[];
};

export type CollectionsFiltersState = {
  rarities: Rarity[] | undefined;
  seasonStartYears: number[] | undefined;
  query: string;
  startedOnly: boolean;
  sort?: string;
};

export enum CollectionsFilterType {
  rarities = 'rarities',
  seasonStartYears = 'seasonStartYears',
  startedOnly = 'startedOnly',
  query = 'query',
}

export type StringifiedCollectionsFiltersState = {
  rarities: string | undefined;
  seasonStartYears: string | undefined;
  query: string | undefined;
  startedOnly: string | undefined;
  sport?: Sport;
  sort?: string;
};

export type Filterable = {
  team?: {
    fullName: string;
  } | null;
  liveRank?: number | null;
  season?: string | null;
  rarity?: Rarity | CardRarity | null;
  filledSlots: number;
  slotsCount: number;
  collectionScore?: number;
};
